import { render } from "./Logout.vue?vue&type=template&id=f074bede&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=f074bede&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f074bede"

export default script